// Built-ins
import React from "react";

// Modules
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

// CSS
import "react-tabs/style/react-tabs.css";

// Custom Made Components
import NavigationBar from "../../core/navigation_bar/navigation_bar";
import Footer from "../../core/footer/footer";
import DistilleryOverView from "./distillery_overview/distillery_overview";
import Gallery from "../../core/gallery/gallery";
import Documents from "../../core/documents/documents";
// Global Variables
import {
  headers,
  restrictedUsers,
} from "../../global_vars";

import axios from "axios";
import Swal from "sweetalert2";

// Variables
window.Swal = Swal;

function getDistilleryId() {
  return window.location.pathname.split("/")[3];
}


// Variables
const VIEW_DISTILLERY = "https://groupplan.gr/api/data_management/distillery/";

// distillery page Class
class Distillery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      distillery: {},
      is_loaded: false,
    };
  }

  componentDidMount() {
    if (restrictedUsers().includes(localStorage.getItem("user"))) {
      this.setState({
        forbidden: true,
      });
    }
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_DISTILLERY + getDistilleryId(), {
        headers: headers,
      })
      .then((res) => {
        this.setState({
          distillery: res.data.distillery,
          is_loaded: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.setState({
            forbidden: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An unknown error has occured.",
          });
        }
      });
  }

  update_state = () => {
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_DISTILLERY + getDistilleryId(), {
        headers: headers,
      })
      .then((res) => {
        this.setState({
          distillery: res.data.distillery,
          is_loaded: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.setState({
            forbidden: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An unknown error has occured.",
          });
        }
      });
  };

  render() {
    return (
      <div>
        <NavigationBar />
        <Tabs>
          <TabList>
            <Tab>Overview</Tab>
            <Tab>Gallery</Tab>
            <Tab>Documents</Tab>
          </TabList>
          <TabPanel>
            <DistilleryOverView />
          </TabPanel>
          <TabPanel>
            <Gallery object={this.state.distillery} object_type={"Distillery"} />
          </TabPanel>
          <TabPanel>
            <Documents object={this.state.distillery} is_loaded={this.state.is_loaded} object_type={"Distillery"} update_state={this.update_state} />
          </TabPanel>
        </Tabs>
        <Footer />
      </div>
    );
  }
}

export default Distillery;
